<template>
  <div>
    <EntityList
      ref="companyPaymentsList"
      :config="config"
      :columns="columns"
      :custom-query="{ company: parentEntity.id }"
      :formatted-columns="formattedColumns"
      :form-fields="formFields"
      authority="Users_Payment"
      embedded
    />
  </div>
</template>

<script>
import EntityList from '@/layouts/entity/EntityList.vue'

import { getSubscriptionTypes } from '@/auth/utils'
import storeModule from '../companyPaymentsStoreModule'

export default {
  components: {
    EntityList,
  },
  props: {
    module: {
      type: String,
      required: true,
    },
    parentEntity: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      paymentMethodOptions: [],
      subscriptionOptions: [],
    }
  },
  computed: {
    config() {
      return {
        store: storeModule,
        module: 'payments',
        endpoint: 'payments',
        route: 'payments',
        title: {
          single: this.$t('Payment Add'),
          plural: this.$t('Payments'),
        },
      }
    },

    columns() {
      return [
        { key: 'id', label: this.$t('id'), sortable: true },
        { key: 'amount', label: this.$t('Amount'), sortable: true },
        { key: 'paymentMethod.title', label: this.$t('Payment Method'), sortable: false },
        { key: 'paymentDate', label: this.$t('Payment Date'), sortable: true },
        { key: 'creationDate', label: this.$t('Creation Date'), sortable: true },
        { key: 'actions', label: this.$t('actions') },
      ]
    },
    formattedColumns() {
      return [
        { key: 'paymentDate', type: 'datetime' },
        { key: 'creationDate', type: 'datetime' },
      ]
    },
    subscriptionTypeOptions() {
      return getSubscriptionTypes()
    },
    formFields() {
      return [
        {
          id: 'companyId',
          type: 'hidden',
          initVal: this.parentEntity.id,
          hidden: true,
        },
        {
          id: 'subscriptionPackage',
          object: true,
          type: 'select',
          label: this.$t('Subscription'),
          options: this.subscriptionOptions,
          required: true,
        },
        {
          id: 'subscriptionType',
          type: 'select',
          label: this.$t('Subscription Type'),
          options: this.subscriptionTypeOptions,
          required: true,
        },
        {
          id: 'amount',
          type: 'text',
          label: this.$t('Paid Amount'),
          required: true,
          rules: 'positive',
        },
        {
          id: 'paymentMethod',
          object: true,
          type: 'select',
          label: this.$i18n.t('Payment Method'),
          options: this.paymentMethodOptions,
          required: true,
        },
        {
          id: 'paymentDate',
          type: 'datetime',
          label: this.$i18n.t('Payment Date'),
          required: true,
          maxDate: new Date(),
        },
        {
          id: 'title',
          type: 'text',
          label: this.$t('title'),
          required: false,
        },
        {
          id: 'comments',
          type: 'quill',
          label: this.$t('comments'),
          required: false,
        },
      ]
    },
  },
  mounted() {
    this.$store.dispatch('app-common/fetchPaymentMethods').then(response => {
      this.paymentMethodOptions = response.data
    })
    this.$store.dispatch('app-common/fetchPlainSubscriptions').then(response => {
      this.subscriptionOptions = response.data
    })
  },
}
</script>
